import React, {Component} from 'react'
import {Spin, Table,message} from 'antd'
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";

const PAGE_SIZE = 5;
const DOWNLOAD_PATH=baseUrl.replace('/oms', '/upload')
export default class DetailUploadTable extends Component{
    constructor() {
        super();
        this.state= {
            loading: false,
            visible: false,
            pageNum: 1,
            params: {},
            tableDataSource: [],
        }

    }
    getUploadFileList=(params=null)=>{
        this.setState({
            loading:true,
        })
        if(!params || !params.pageNum) {
            if(!params){
                params = this.state.params
            }
            params = Object.assign(params,{
                pageNum: this.state.pageNum,
                pageSize: PAGE_SIZE
            })
        }
        let result = ajax(baseUrl+"/api/v1/p/oms/resultFiles",params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    total: resp.data.total,
                    tableDataSource:resp.data.rows
                })
            }else{
                message.error(resp.message)
                this.setState({
                    total: 0,
                    tableDataSource:[]
                })
            }
        }).catch(()=>{
            this.setState({
                total: 0,
                tableDataSource:[]
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.orderId!=this.state.orderId) {
            this.setState({
                orderId: nextProps.orderId,
                fileType:nextProps.fileType,
                params:{
                    orderId:nextProps.orderId,
                    fileType:nextProps.fileType,
                }
            },()=>{
                this.getUploadFileList()
            })
        }
    }

    getReadableFileSizeString=(fileSizeInBytes)=> {
        var i = -1;
        var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
        do {
            fileSizeInBytes = fileSizeInBytes / 1024;
            i++;
        } while (fileSizeInBytes > 1024);

        return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    };
    render() {
        let dateColName=this.props.fileType==="upload"?"上传时间":"生成时间"
        const columns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (this.state.pageNum - 1) * PAGE_SIZE }</span>
                )
            },
            {
                title: '文件名',
                dataIndex: 'fileName',
                render: (text,record) => (
                    <span>
                        <a href={DOWNLOAD_PATH+record.filePath}>{text}</a>
                    </span>
                )
            },
            {
                title: '文件大小',
                dataIndex: 'fileSize',
                render: (text,record) => (
                    <span>
                        {this.getReadableFileSizeString(text)}
                    </span>
                )
            },
            {
                title: dateColName,
                dataIndex: 'createDt',
            }
        ];
        return(
            <Spin spinning={this.state.loading}>
                <Table
                    rowKey='id'
                    size="middle"
                    bordered
                    columns={columns}
                    dataSource={this.state.tableDataSource}
                    pagination={{
                        current: this.state.pageNum,
                        total:this.state.total,
                        pageSize:PAGE_SIZE,
                        showQuickJumper: true,
                        onChange:(page, pageSize)=>{
                            this.setState({
                                pageNum:page
                            },()=>{
                                this.getUploadFileList()
                            })
                        }
                    }}
                />
            </Spin>
        )
    }
}